import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { toggleSiteSelection, clearSiteSelection } from '../../redux/features/timecard/siteSlice';
import { ChevronLeft } from 'lucide-react';

const FilterSelectSite: React.FC = () => {
  const dispatch = useDispatch();
  const selectedSites = useSelector((state: RootState) => state.site.selectedSites);
  const sites = useSelector((state: RootState) => state.site.sites);

  return (
    <div className="min-h-screen bg-white w-full max-w-md mx-auto">
      <div className="flex items-center justify-between bg-white p-4 shadow-md sticky top-0 z-10">
        <button onClick={() => window.history.back()} className="text-black">
          <ChevronLeft size={24} />
        </button>
        <h1 className="text-lg font-medium text-black">Select Site</h1>
        <button onClick={() => dispatch(clearSiteSelection())} className="text-black font-medium">
          Clear
        </button>
      </div>

      <div className="p-4 space-y-4">
        <div
          className="flex items-center justify-between bg-gray-100 p-4 rounded-md"
          onClick={() => dispatch(toggleSiteSelection('all'))}
        >
          <span className="text-black font-semibold">Select All</span>
          <input
            type="checkbox"
            checked={selectedSites.length === sites.length}
            onChange={() => dispatch(toggleSiteSelection('all'))}
            className="h-5 w-5 text-blue-500"
            title="Select All"
          />
        </div>
        {sites.map((site) => (
          <div
            key={site.id}
            className="flex items-center justify-between p-4 border-b border-gray-200"
            onClick={() => dispatch(toggleSiteSelection(site.id))}
          >
            <span className="text-black">{site.name}</span>
            <input
              type="checkbox"
              checked={selectedSites.includes(site.id)}
              onChange={() => dispatch(toggleSiteSelection(site.id))}
              className="h-5 w-5 text-blue-500"
              title={`Select ${site.name}`}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default FilterSelectSite;
